import { useParams } from "react-router-dom";
import { useAuth } from "@/api/auth/AuthProvider";
import { useEffect, useMemo } from "react";
import {
  getLastWorkspaceId,
  resolveWorkspaceId,
  setLastWorkspaceId,
} from "@/utils/workspace-utils/workspace-utils";

export const useWorkspaceId = () => {
  const { workspaceId: routeWorkspaceId } = useParams();
  const { defaultWorkspaceId, user } = useAuth();
  const resolvedWorkspaceId = useMemo(() => {
    return resolveWorkspaceId({
      routeWorkspaceId,
      lastWorkspaceId: getLastWorkspaceId(),
      workspaces: user?.Workspaces,
      fallbackWorkspaceId: defaultWorkspaceId,
    });
  }, [routeWorkspaceId, user?.Workspaces, defaultWorkspaceId]);

  useEffect(() => {
    setLastWorkspaceId(resolvedWorkspaceId);
  }, [resolvedWorkspaceId]);

  return {
    workspaceId: resolvedWorkspaceId,
    routeWorkspaceId,
  };
};

export default useWorkspaceId;
